import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Typography,
} from "@mui/material";
import DOMPurify from "dompurify";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "../../../../hooks/useTranslation";

interface HtmlModalProps {
  open: boolean;
  onClose: () => void;
  htmlContent: string;
  ishtml: boolean;
}

export const HtmlModal = ({
  open,
  onClose,
  htmlContent,
  ishtml,
}: HtmlModalProps) => {
  let displayHtml = htmlContent;
  if (ishtml) {
    displayHtml = DOMPurify.sanitize(htmlContent);
  } else {
    displayHtml = displayHtml.replaceAll("\n", "<br>");
    displayHtml = displayHtml.replaceAll(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
    );
  }

  const { translate } = useTranslation(
    "pages.stores.mailNotification.forwardedMailsList",
  );
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      scroll="paper"
      TransitionComponent={Fade}
    >
      <DialogTitle
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography variant="h6">{translate("mailContent")}</Typography>
        <IconButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          dangerouslySetInnerHTML={{ __html: displayHtml }}
          sx={{ minHeight: "50vh" }}
        />
      </DialogContent>
    </Dialog>
  );
};
